import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { logout } from "../lib/api";
import ConnectManager from "../components/ConnectManager";

export default function ConnectHome() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-cream pb-16" data-testid="connect-home">
      <header className="bg-navy sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
          <img src="/logo-supera-light.png" alt="Supera" className="h-11 w-auto object-contain" />
          <button onClick={() => { logout(); navigate("/login"); }} className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm font-semibold"><LogOut className="w-4 h-4" /> Salir</button>
        </div>
      </header>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <button onClick={() => navigate(-1)} className="mb-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#6B7688] hover:text-[#0A1C30]"><ArrowLeft className="w-4 h-4" /> Volver</button>
        <ConnectManager />
      </div>
    </div>
  );
}
